import {
  EDisbursementMethod,
  ETxnSpeed,
  payrollRunSchema,
  PayrollRunType,
  zSchema,
} from "@zeal/common";

export const createPayrollRunRequestSchema = zSchema.object({
  checks: zSchema.array(zSchema.string()).optional(),
  companyID: zSchema.string(),
  disbursementMethod: zSchema.nativeEnum(EDisbursementMethod).optional(),
  payDate: zSchema.string(),
  payFrequency: zSchema.string(),
  reportingPeriodID: zSchema.string(),
  speed: zSchema.nativeEnum(ETxnSpeed),
  type: zSchema.nativeEnum(PayrollRunType),
});

export type TCreatePayrollRunRequestSchema = zSchema.TypeOf<
  typeof createPayrollRunRequestSchema
>;

export const createPayrollRunResponseSchema = payrollRunSchema;

export type TCreatePayrollRunResponseSchema = zSchema.TypeOf<
  typeof createPayrollRunResponseSchema
>;
